import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import { CREATE_LOG_SUCCESS, FETCH_LOG_SUCCESS, GET_LOG_SUCCESS, SAVE_LOG_QUERY } from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_LOG_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_LOG_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_LOG_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_LOG_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { log } = store.getState();
      const { query } = log;
      const response = await axios.get(`/external-request-log?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/external-request-log`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/log');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/external-request-log/${id}`, payload);
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/log');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/external-request-log/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/external-request-log/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
